
export const MESSAGES_UPDATE_COMMENT= "Updated comment!"
export const MESSAGES_DELETE_COMMENT= "Delete comment!"

